<template>
  <div v-if="relatie">
    <b-alert
      :show="boodschap !== null"
      dismissible
      variant="danger"
      @dismissed="boodschap = null"
    >
      {{ boodschap }}
    </b-alert>

    <!-- Nieuw aangemaakte key: eenmalig tonen -->
    <b-alert
      :show="newSecret !== null"
      variant="warning"
    >
      <h5>Nieuwe API key aangemaakt</h5>
      <p>
        Kopieer deze key nu; hij wordt hierna <strong>niet meer getoond</strong>.
      </p>
      <b-input-group>
        <b-form-input
          :value="newSecret"
          readonly
        />
        <b-input-group-append>
          <b-button
            variant="primary"
            @click="copySecret"
          >
            <i class="fa fa-copy" /> {{ copied ? 'Gekopieerd!' : 'Kopieer' }}
          </b-button>
          <b-button
            variant="secondary"
            @click="newSecret = null"
          >
            Sluiten
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-alert>

    <b-table
      :items="apiKeys"
      :fields="fields"
      :busy="busy"
      bordered
      small
      show-empty
      empty-text="Geen API keys voor deze relatie."
    >
      <template #cell(Prefix)="data">
        <code>{{ data.item.Prefix }}</code>
      </template>
      <template #cell(Actief)="data">
        <b-badge :variant="data.item.Actief ? 'success' : 'secondary'">
          {{ data.item.Actief ? 'Actief' : 'Inactief' }}
        </b-badge>
      </template>
      <template #cell(acties)="data">
        <b-button
          size="sm"
          :variant="data.item.Actief ? 'warning' : 'success'"
          class="mr-1"
          :disabled="busy"
          @click="toggleActief(data.item)"
        >
          {{ data.item.Actief ? 'Deactiveren' : 'Activeren' }}
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          :disabled="busy"
          @click="confirmDelete(data.item)"
        >
          <i class="fa fa-trash" /> Intrekken
        </b-button>
      </template>
    </b-table>

    <b-button
      variant="success"
      :disabled="busy"
      @click="createKey"
    >
      <i class="fa fa-plus" /> Nieuwe API key
    </b-button>
  </div>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
  mixins: [serviceMixin],
  props: {
    relatie: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      apiKeys: [],
      newSecret: null,
      copied: false,
      busy: false,
      fields: [
        { key: "Prefix", label: "API key" },
        { key: "Actief", label: "Status" },
        { key: "acties", label: "Acties" }
      ]
    };
  },
  computed: {
    keysUrl() {
      if (!this.relatie) return null;
      return `/relaties/${this.relatie.Id}/apikeys`;
    }
  },
  watch: {
    relatie: {
      immediate: true,
      handler(newRelatie) {
        if (!newRelatie) return;
        // Toon direct de al ingeladen (gemaskeerde) keys uit de relatie prop
        if (Array.isArray(newRelatie.ApiKeys)) {
          this.apiKeys = newRelatie.ApiKeys;
        }
        // En haal de actuele lijst op zodra de relatie beschikbaar is
        this.loadKeys();
      }
    }
  },
  methods: {
    loadKeys() {
      var vm = this;
      if (!this.keysUrl) return;
      vm.busy = true;
      this.get(this.keysUrl)
        .then((response) => {
          vm.apiKeys = response.data.apikeys;
        })
        .catch(() => {
          // Endpoint (nog) niet beschikbaar; val terug op de keys uit de relatie prop
          if (vm.relatie && Array.isArray(vm.relatie.ApiKeys)) {
            vm.apiKeys = vm.relatie.ApiKeys;
          }
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    createKey() {
      var vm = this;
      vm.busy = true;
      vm.copied = false;
      this.post(this.keysUrl, {})
        .then((response) => {
          vm.newSecret = response.data.secret;
          vm.apiKeys.push(response.data.apikey);
        })
        .catch((error) => {
          vm.boodschap = "Fout bij aanmaken API key: " + error;
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    toggleActief(key) {
      var vm = this;
      vm.busy = true;
      this.put(`${this.keysUrl}/${key.Id}`, { actief: !key.Actief })
        .then((response) => {
          var idx = vm.apiKeys.findIndex((k) => k.Id === key.Id);
          if (idx !== -1) vm.$set(vm.apiKeys, idx, response.data.apikey);
        })
        .catch((error) => {
          vm.boodschap = "Fout bij bijwerken API key: " + error;
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    confirmDelete(key) {
      var vm = this;
      this.$bvModal
        .msgBoxConfirm(
          `Weet je zeker dat je API key ${key.Prefix} wilt intrekken? Systemen die deze key gebruiken verliezen direct toegang.`,
          {
            title: "API key intrekken",
            okVariant: "danger",
            okTitle: "Intrekken",
            cancelTitle: "Annuleren"
          }
        )
        .then((confirmed) => {
          if (confirmed) vm.deleteKey(key);
        });
    },
    deleteKey(key) {
      var vm = this;
      vm.busy = true;
      this.delete(`${this.keysUrl}/${key.Id}`)
        .then(() => {
          vm.apiKeys = vm.apiKeys.filter((k) => k.Id !== key.Id);
        })
        .catch((error) => {
          vm.boodschap = "Fout bij intrekken API key: " + error;
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    copySecret() {
      var vm = this;
      navigator.clipboard.writeText(this.newSecret).then(() => {
        vm.copied = true;
      });
    }
  }
};
</script>
